angular.module('pipNavIcon', ['ngMaterial', 'pipNav.Translate', 'pipNav.Templates']);

import './NavIconConfig';
import './INavIconService';
import './NavIconService';
import './NavIcon';


export * from './NavIconConfig';
export * from './INavIconService';
export * from './NavIconService';
